export default __webpack_public_path__ + "static/media/trade_09.16daa270.png";